// removed by extract-text-webpack-plugin
module.exports = {"list-product-result":"list-product-result","product-wrap":"product-wrap","product":"product"};


//////////////////
// WEBPACK FOOTER
// ./components/list-product/list-product-result/style.scss
// module id = ./components/list-product/list-product-result/style.scss
// module chunks = 0